import React, { useState } from "react";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { Grid } from "@material-ui/core";
import Buy from "../components/buy";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: "50vh",
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      type: "spring",
      stiffness: 100,
    },
  },
  next: {
    y: "-100vh",
    transition: { ease: "easeInOut", duration: 0.8 },
  },
  back: {
    y: "+100vh",
    transition: { ease: "easeInOut", duration: 0.8 },
  },
};

const Slide2 = ({ screen }) => {
  const [exit, setExit] = useState("next");
  return (
    <motion.div
      className="about-container"
      variants={containerVariants}
      initial="hidden"
      animate="show"
      exit={exit}
    >
      <div
        style={{
          height: "100vh",
          width: "80%",
          background: "black",
          margin: "auto",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} style={{ padding: 0 }}>
            <Buy screen={screen} />
          </Grid>
          <Grid item xs={12} md={6} style={{ background: "black" }}>
            <div style={{ textAlign: screen > 600 ? "right" : "center" }}>
              <motion.h1
                initial={{ y: 10 }}
                animate={{
                  y: -10,
                  transition: {
                    duration: 1,
                    ease: "easeIn",
                    repeat: Infinity,
                    repeatType: "reverse",
                  },
                }}
                onClick={() => {
                  setExit("back");
                }}
              >
                <Link className="link" to="/slide1">
                  &#8657;
                </Link>
              </motion.h1>
            </div>
            <div
              style={{
                display: screen > 600 ?"grid" : "inline-block",
                alignItems: "center",
                minHeight: "70vh",
              }}
              data-aos="fade-up"
              data-aos-offset="500"
            >
              <div
                style={{
                  color: "white",
                  fontSize: screen > 600 ? "4rem" : "2rem",
                  lineHeight: screen > 600 ? "3rem" : "2rem",
                  textAlign: screen > 600 ? "right" : "center",
                  fontFamily: "Champagne",
                }}
              >
                Diana compro una casa y lo financió con un
                <span style={{ color: "#77b516" }}> CReDITO HIPOTECARIO</span>
              </div>
            </div>
            <div style={{ textAlign: screen > 600 ? "right" : "center" }}>
              <motion.h1
                initial={{ y: -10 }}
                animate={{
                  y: 10,
                  transition: {
                    duration: 1,
                    ease: "easeIn",
                    repeat: Infinity,
                    repeatType: "reverse",
                  },
                }}
              >
                <Link className="link" to="/slide3">
                  &#8659;
                </Link>
              </motion.h1>
            </div>
          </Grid>
        </Grid>
      </div>
    </motion.div>
  );
};

export default Slide2;
